import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import { ThemedValues } from 'styles/themed'

export const ThemedBadgeStyles = StyleSheet.create({
	container: {
		position: 'absolute',
		width: 18,
		height: 18,
		borderRadius: ThemedValues.borderRadius,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: colorList.RED.primary
	},
	text: {
		fontSize: 9,
		color: colorList.WHITE.primary
	}
});
